import { ReactNode } from 'react';
import { RiskTier } from '../../../Api/Projects/projectsApi';
import { RISK_TIER_BANNER_STYLES } from './riskTierStyles';

export interface RiskBannerProps {
  tier: RiskTier;
  children: ReactNode;
  testId?: string;
}

// Tier-colored status strip rendered flush above a dark widget card
// (rounded-t only — the card below carries the matching rounded-b).
export const RiskBanner = ({ tier, children, testId }: RiskBannerProps) => {
  const style = RISK_TIER_BANNER_STYLES[tier];

  return (
    <div
      className="flex items-center gap-2 rounded-t-lg px-5 h-12 border border-b-0"
      style={{ backgroundColor: style.bg, borderColor: style.border }}
      data-testid={testId}>
      {style.icon && (
        <span
          className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-[11px] font-bold leading-none text-white"
          style={{ backgroundColor: style.icon }}>
          !
        </span>
      )}
      <span className="text-[13px] font-semibold text-grey-9">{children}</span>
    </div>
  );
};
